export default __webpack_public_path__ + "static/media/share-token-pic.fabab7d8.svg";